import { useCallback } from "react";
import { GroupsApi, useAPIAction } from "melco-shared-logic";

export const useMachineGroupsWithAPIAction = () => {
  const [getAllMachinesGroups] = useAPIAction(
    GroupsApi,
    async (api: GroupsApi) => {
      const data = await api.statisticsGroupsSearch({
        searchText: undefined,
      });

      return {
        successMessages: [],
        data,
      };
    },
    {
      translationPrefix: "",
    }
  );

  return useCallback(async () => {
    try {
      return await getAllMachinesGroups();
    } catch (e) {
      // error handling is already done in useAPIAction
    }
  }, [getAllMachinesGroups]);
};
